export const getAllOnboardingLetterQuery = `query employeeOnboardLetterByAll{
  employeeOnboardLetterByAll {
    success
    error
    message
    data {
      id
      fullName
      empId
      department
      designation
      doj
      ctc
      salaryStructure {
        id
        structureName
      }
      basicPercentage
      gross
      totalDeductions
      totalBenefits
      netPay
      overallSum
      difference
      breakdown
      onboardLetterPdf
      isDeleted
      createdAt
      updatedAt
    }
  }
}`;

export const allDepartmentQuery = `
query {
    allDepartment {
    id
    departmentName
    departmentCode
    }
}`;

export const allDesignationQuery = ` 
query{
    allDesignation{
        id
        departmentName
        designation
        lastUpdate
    }
}`;

export const allSalaryStructuresQuery = `
query allsalarystructure{
    salaryStructures {
        id
        structureName
        salaryType
        components {
        id
        percentage
        amount
        type
        calculatedFrom
        }
    }
}`;

export const getOnboardLetterByIdQuery =`
query employeeOnboardLetterById($id: ID!) {
  employeeOnboardLetterById(id: $id) {
    success
    error
    message
    data {
      id
      fullName
      empId
      department
      designation
      doj
      ctc
      salaryStructure {
        id
        structureName
      }
      basicPercentage
      gross
      totalDeductions
      totalBenefits
      netPay
      overallSum
      difference
      breakdown
      onboardLetterPdf
      isDeleted
      createdAt
      updatedAt
    }
  }
}`;

export const submitOnboardLetterQuery = `
mutation CreateEmployeeOnboardLetter(
  $emp_id:String!
  $full_name: String!
  $department: String!
  $designation: String!
  $doj: Date!
  $ctc: Float!
  $salary_structure_id: ID!
  $basic_percentage: Float!
) {
  createEmployeeOnboardLetter(
    empId:$emp_id
    fullName: $full_name
    department: $department
    designation: $designation
    doj: $doj
    ctc: $ctc
    salaryStructureId: $salary_structure_id
    basicPercentage: $basic_percentage
  ) {
    success
    error
    message
    data {
      id
      fullName
      department
      designation
      doj
      onboardLetterPdf
      ctc
      basicPercentage
      gross
      totalDeductions
      totalBenefits
      netPay
      overallSum
      difference
      breakdown
    }
  }
}`;

export const updateOnboardLetterQuery = `
mutation UpdateEmployeeOnboardLetter(
  $id: ID!
  $emp_id:String
  $full_name: String
  $department: String
  $designation: String
  $doj: Date
  $ctc: Float
  $salary_structure_id: ID
  $basic_percentage: Float
  $onboard_letter_pdf: Upload
) {
  updateEmployeeOnboardLetter(
    id: $id
    empId:$emp_id
    fullName: $full_name
    department: $department
    designation: $designation
    doj: $doj
    ctc: $ctc
    salaryStructureId: $salary_structure_id
    basicPercentage: $basic_percentage
    onboardLetterPdf: $onboard_letter_pdf
  ) {
    success
    error
    message
    data {
      id
      fullName
      department
      designation
      doj
      onboardLetterPdf
      ctc
      basicPercentage
      gross
      totalDeductions
      totalBenefits
      netPay
      overallSum
      difference
      breakdown
    }
  }
}`;

export const deleteEmployeeOnboardingLetterQuery = `
mutation deleteEmployeeOnboardLetter($id: ID!) {
  deleteEmployeeOnboardLetter(id: $id) {
    success
    message
  }
}`
